module.exports = __webpack_public_path__ + "media/images/files-b3fac6f2fe2d41264ef2da02473e322b.png";